var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_1244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.27778 3.47223C2.54107 3.47223 1.83453 3.76489 1.31359 4.28582C0.792658 4.80676 0.5 5.51329 0.5 6.25001L0.5 18.75C0.5 19.4867 0.792658 20.1933 1.31359 20.7142C1.83453 21.2351 2.54107 21.5278 3.27778 21.5278H7.44444V3.47223H3.27778ZM22.7222 3.47223H18.5556V21.5278H22.7222C23.4589 21.5278 24.1655 21.2351 24.6864 20.7142C25.2073 20.1933 25.5 19.4867 25.5 18.75V6.25001C25.5 5.51329 25.2073 4.80676 24.6864 4.28582C24.1655 3.76489 23.4589 3.47223 22.7222 3.47223Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44409 3.47223H18.5552V21.5278H7.44409V3.47223Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4257 15.3562C14.2576 15.4528 15.0034 15.5396 15.8347 15.6347L15.6229 14.9389C15.6073 14.879 15.6094 14.8159 15.629 14.7572C15.6486 14.6985 15.6849 14.6468 15.7333 14.6083L18.1493 12.6403L17.6493 12.4049C17.4291 12.3264 17.4895 12.2021 17.5694 11.9035L17.9382 10.559L16.5347 10.8555C16.3979 10.8764 16.3069 10.7896 16.2861 10.7062L16.1048 10.0736L14.9951 11.3194C14.8375 11.5194 14.518 11.5194 14.6173 11.0583L15.0916 8.53471L14.4548 8.86457C14.2764 8.96457 14.0979 8.98124 13.9986 8.80277L13.1201 7.15971L12.2416 8.80277C12.1416 8.98124 11.9632 8.96457 11.7847 8.86457L11.1486 8.53471L11.6229 11.0583C11.7229 11.5194 11.4027 11.5194 11.2451 11.3194L10.1354 10.0743L9.95482 10.7069C9.93399 10.7903 9.84232 10.8771 9.70552 10.8562L8.30205 10.5597L8.6708 11.9042C8.74927 12.2028 8.81038 12.3271 8.59024 12.4055L8.09024 12.641L10.5062 14.609C10.602 14.6833 10.6507 14.8174 10.6159 14.9396L10.4041 15.6354L12.8139 15.3569C12.8875 15.3569 12.9361 15.3979 12.9354 15.4826L12.7868 18.0549H13.4507L13.3027 15.4826C13.3041 15.3972 13.352 15.3562 13.4257 15.3562Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_1244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/Canada.b7336c3032ef58a6d714b081bc4df9dc.svg";
export { ForwardRef as ReactComponent };